import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

type ConsentWarningDialogProps = {
  open: boolean;
  onCancel: () => void;
  onProceed: () => void;
};

export const ConsentWarningDialog = ({
  open,
  onCancel,
  onProceed,
}: ConsentWarningDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <div className="flex items-center gap-2">
            <ShieldAlert className="h-5 w-5 text-warning" />
            <DialogTitle>{t('Consent required')}</DialogTitle>
          </div>
          <DialogDescription>
            {t('The client requires written consent to access their data. Only access it if written consent has been given to you.')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            {t('Cancel')}
          </Button>
          <Button onClick={onProceed}>{t('Access')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
